import { Country } from '../country.model';
import { Balance } from '../finance/balance.model';
import { Currency } from './currency.model';

export class User {
  id: number;
  email: string;
  password: string;
  nameFirm: string;
  personSurname: string;
  personName: string;
  personPatronymic: string;
  phone: string;
  dateRegistration: Date;
  languageCode: string;
  guid: string;
  activated: boolean;
  blocked: boolean;
  notifyInSupport: boolean;
  country: Country;
  currency: Currency;
  publicGuid: string;
  role: RoleEnum;
  parentId: number;
  balans: Balance;
  lastActivityDate?: Date;

  constructor(user?: User | any) {
    user = user || {};
    this.id = user.id || 0;
    this.email = user.email || '';
    this.password = user.password || '';
    this.activated = user.activated || false;
    this.nameFirm = user.nameFirm || '';
    this.personSurname = user.personSurname || '';
    this.personName = user.personName || '';
    this.personPatronymic = user.personPatronymic || '';
    this.phone = user.phone || '';
    this.dateRegistration = user.dateRegistration || new Date();
    this.languageCode = user.languageCode || 'en';
    this.guid = user.guid || '';
    this.blocked = user.blocked || false;
    this.country = user.country || new Country();
    this.currency = user.currency || new Currency();
    this.notifyInSupport = user.notifyInSupport || true;
    this.publicGuid = user.publicGuid || '';
    this.role = user.role || RoleEnum.User;
    this.parentId = user.parentId || 0;
    this.balans = user.balans || new Balance();
    this.lastActivityDate = user.lastActivityDate || undefined;
  }
}

export class ShortUserInfo {
  id: number;
  email: string;
  personSurname: string;
  personName: string;
  personPatronymic: string;
  phone: string;
  role: RoleEnum;
}

export enum RoleEnum {
  User,
  Admin,
  Manager,
  TechSupport,
  SeniorTechSupport,
}
